import projectResourceFactory from '../resources/ProjectResourceFactory'

export default {
  methods: {
    setProjectsCount() {
      this.projectTypes.forEach(type => {
        this.setProjectsCountByType(type)
      })
    },
    setProjectsCountByType(type) {
      return projectResourceFactory.create(type).count()
        .then(data => this.$store.commit('SET_PROJECTS_COUNT', {type: type, count: data.count}), console.error)
    }
  },
  computed: {
    projectTypes() {
      return this.$store.getters.projectTypes
    }
  }
}
